import { genreOptions, regionOptions, yearOptions } from "@/mocks/categories";

interface FilterPanelProps {
  selectedGenres: string[];
  selectedRegions: string[];
  selectedYears: string[];
  onToggle: (group: "genre" | "region" | "year", value: string) => void;
  onReset: () => void;
}

interface FilterGroupProps {
  title: string;
  options: string[];
  selected: string[];
  onToggle: (value: string) => void;
}

function FilterGroup({ title, options, selected, onToggle }: FilterGroupProps) {
  return (
    <div>
      <h4 className="mb-3 font-heading text-sm font-bold text-foreground-100">{title}</h4>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = selected.includes(option);
          return (
            <button
              key={option}
              type="button"
              onClick={() => onToggle(option)}
              className={`whitespace-nowrap rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${
                active
                  ? "border-primary-500 bg-primary-500 text-background-50"
                  : "border-background-300 bg-background-100 text-foreground-400 hover:border-primary-500/60 hover:text-primary-400"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default function FilterPanel({
  selectedGenres,
  selectedRegions,
  selectedYears,
  onToggle,
  onReset,
}: FilterPanelProps) {
  const hasFilters =
    selectedGenres.length > 0 || selectedRegions.length > 0 || selectedYears.length > 0;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-50">
          <i className="ri-filter-3-line text-primary-400"></i>
          筛选条件
        </h3>
        {hasFilters && (
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-foreground-500 transition-colors hover:text-primary-400"
          >
            <i className="ri-refresh-line"></i>
            重置
          </button>
        )}
      </div>
      <FilterGroup
        title="类型"
        options={genreOptions}
        selected={selectedGenres}
        onToggle={(value) => onToggle("genre", value)}
      />
      <FilterGroup
        title="地区"
        options={regionOptions}
        selected={selectedRegions}
        onToggle={(value) => onToggle("region", value)}
      />
      <FilterGroup
        title="年份"
        options={yearOptions}
        selected={selectedYears}
        onToggle={(value) => onToggle("year", value)}
      />
    </div>
  );
}